import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const ShippingPolicy = () => {
  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    color: '#333'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '40px'
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: '10px'
  };

  const sectionStyle = {
    marginBottom: '30px',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const sectionTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: '15px',
    borderBottom: '2px solid #3498db',
    paddingBottom: '8px'
  };

  const textStyle = {
    fontSize: '1rem',
    marginBottom: '10px',
    color: '#555'
  };

  const listStyle = {
    paddingLeft: '20px',
    marginBottom: '15px'
  };

  const listItemStyle = {
    marginBottom: '8px',
    color: '#555'
  };

  const highlightStyle = {
    color: '#e74c3c',
    fontWeight: 'bold'
  };

  const noteStyle = {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '4px',
    padding: '15px',
    margin: '20px 0',
    color: '#856404'
  };

  return (
    <>
    <Navbar />
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={titleStyle}>Shipping Policy</h1>
        <p style={textStyle}>Fast, reliable delivery for your watches and eyewear</p>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Shipping Options & Delivery Times</h2>
        <p style={textStyle}>We offer several shipping options to meet your needs:</p>
        <ul style={listStyle}>
          <li style={listItemStyle}>
            <strong>Standard Shipping:</strong> 5-7 business days
          </li>
          <li style={listItemStyle}>
            <strong>Express Shipping:</strong> 2-3 business days
          </li>
          <li style={listItemStyle}>
            <strong>Next Day Delivery:</strong> 1 business day
          </li>
          <li style={listItemStyle}>
            <strong>Free Shipping:</strong> Orders over ₹5000- 5-7 business days
          </li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Processing Time</h2>
        <p style={textStyle}>
          All orders are processed within <span style={highlightStyle}>1-2 business days</span> 
          (Monday-Friday, excluding holidays). Orders placed after 2 PM will be processed 
          the next business day.
        </p>
        <p style={textStyle}>
          <strong>Note:</strong> Prescription eyewear requires additional processing time 
          for lens customization (3-5 business days).
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Shipping Areas</h2>
        <p style={textStyle}>
          We currently ship to all India.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Order Tracking</h2>
        <p style={textStyle}>
          Once your order ships, you'll receive a confirmation email with your 
          tracking number. You can track your package using our order tracking 
          system or directly with the carrier.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Special Handling</h2>
        <p style={textStyle}>
          All our products are packaged with care:
        </p>
        <ul style={listStyle}>
          <li style={listItemStyle}>Watches: Shock-resistant packaging with protective cases</li>
          <li style={listItemStyle}>Eyewear: Hard-shell cases with microfiber cleaning cloths</li>
          <li style={listItemStyle}>Prescription glasses: Anti-scratch coating and secure packaging</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Delivery Issues</h2>
        <p style={textStyle}>
          If you experience any issues with your delivery, please contact us within 
          48 hours of delivery date:
        </p>
        <ul style={listStyle}>
          <li style={listItemStyle}>Damaged packages</li>
          <li style={listItemStyle}>Incorrect items received</li>
          <li style={listItemStyle}>Non-delivery (after expected delivery date)</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Signature Requirements</h2>
        <p style={textStyle}>
          Orders over ₹2500 require signature confirmation upon delivery. 
          You'll receive notification when signature is required.
        </p>
      </div>

      <div style={noteStyle}>
        <strong>Important:</strong> Please ensure your shipping address is correct. 
        We are not responsible for packages shipped to incorrect addresses provided 
        during checkout. Address changes must be requested within 1 hour of order placement.
      </div>

      <div style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Contact Information</h2>
        <p style={textStyle}>
          For shipping-related questions, contact our customer service team:
        </p>
        <p style={textStyle}>
          📧 Email: suryawanshiwatch1918@gmail.com<br/>
          📞 Phone: +91 79729 64344<br/>
          ⏰ Hours: Mon-Fri 9AM-6PM 
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ShippingPolicy;